import { useCallback, useEffect } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { fetchCountries, selectCountriesInfo } from '../../slices/countries/countriesSlice';
import { LOCATION_EXCEPTIONS } from '../constants/location_exceptions';
import { useAuth } from '@clerk/clerk-react';

export const useCountriesInfo = () => {
  const { isSignedIn } = useAuth();
  const dispatch = useAppDispatch();
  const locationIncludeExceptionUrl = LOCATION_EXCEPTIONS.some((el) => {
    return location.pathname.includes(el);
  });
  const countries = useAppSelector(selectCountriesInfo);
  const shouldFetchCountries = isSignedIn && countries.length === 0 && !locationIncludeExceptionUrl;
  const getCountries = useCallback(() => {
    if (shouldFetchCountries) {
      dispatch(fetchCountries());
    }
  }, [dispatch, shouldFetchCountries]);
  useEffect(() => {
    getCountries();
  }, [getCountries]);
  return {
    countries,
  };
};
